import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const creditCardRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/credit-card',
  component: lazyRouteComponent(() => import('@/pages/credit-card/credit-card-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const detailCreditCardRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/credit-card/$id',
  component: lazyRouteComponent(() => import('@/pages/credit-card/credit-card-detail-page')),
});
